<template>
  <el-menu
    v-if="routes.length > 0"
    :default-active="activeIndex"
    class="el-menu-style"
    mode="horizontal"
    @select="handleSelect"
    :router="true"
  >
    <el-menu-item
      v-for="route in routes"
      :key="route"
      :route="route"
      :base-path="route.path"
      :index="route.path"
    >
      <font-awesome-icon :icon="['fas', route.meta.icon]" v-if="route.meta && route.meta.icon" />
      {{ route.name }}
    </el-menu-item>
  </el-menu>
</template>

<script lang="ts" setup>
import { getAvailableRoutes } from "@/router";
import { ref } from "vue";
import router from "@/router";
let routes = router.currentRoute.value.meta.menuSingle ? [router.currentRoute.value] : getAvailableRoutes();
const group = router.currentRoute.value.meta.group;
const groupedRoutesCount = group ? routes.filter((route) => route.meta.group == group).length : 1;
if (groupedRoutesCount > 1) {
  routes = getAvailableRoutes().filter((r) => r.meta.group === group);
} else {
  routes = [];
}
const activeIndex = ref(window.location.pathname);
</script>
